import {onFind} from "@elements/init-modules-in-scope";
import {find, hasClass} from '@elements/dom-utils';
import Collapse from 'bootstrap/js/dist/collapse';

export function init() {
    onFind('.js-allergene-scroll-to', function (baseElement) {
        const itemId = new URLSearchParams(window.location.search).get('item');
        const allergeneId = baseElement.getAttribute('data-allergene-id');

        if (itemId && allergeneId) {
            let allergeneAccordionItem = find(`#${allergeneId}Collapse${itemId}`, baseElement);
            if (!hasClass('show', allergeneAccordionItem)) {
                let collapse = Collapse.getOrCreateInstance(allergeneAccordionItem);
                collapse.show();
            }
            window.scrollTo(window.scrollX, allergeneAccordionItem.offsetTop - 200);
        }
    });
}